module.exports = __webpack_public_path__ + "media/images/gallery/nebulae_off-135260be4ec3bf7ff642f0b88e6be370.gif";